import React from "react";
import { Route, Switch, useHistory, useParams } from "react-router-dom";

// MUI imports for Icons
import ArrowBack from '@mui/icons-material/ArrowBack'; // For Exit
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import HelpOutline from '@mui/icons-material/HelpOutline';
import LockOpenOutlined from '@mui/icons-material/LockOpenOutlined'; // For Unlock All
import LogoutOutlined from '@mui/icons-material/LogoutOutlined';

// Your component imports (assuming paths)
import AssignmentIcon from '@mui/icons-material/Assignment';
import { ButtonComponent, Type } from '../base/button/Button';
import { PageContainerComponent } from '../base/pageContainer/PageContainer';
import { AnimatedStack } from '../MotionMui/MotionMui'; // Assuming path
import { TeamUrlParams } from "../team/TeamContext"; // Assuming path
import { ResetTutorials } from "./resetTutorials/ResetTutorials";
import { ResetWorldTour } from './resetWorldTour/ResetWorldTour';
import { ResignFromTeam } from "./resignFromTeam/ResignFromTeam";
import { SignOut } from "./signOut/SignOut";
import { UnlockAllWorldTour } from './unlockAllWorldTour/unlockAllWorldTour';

// Removed FontAwesome imports

const OptionsList = () => { // Removed props: any as it wasn't used
    const { teamId } = useParams<TeamUrlParams>(); // Destructure teamId directly
    const history = useHistory();

    // Helper to add margin to icons
    const iconStyle = { marginRight: '0.5vmin' }; // Adjust spacing as needed

    return (
        <PageContainerComponent>
            {/* Use root={true} if this is the top-level animation container on the page */}
            <AnimatedStack root={true} spacing={2} staggerSpeed='Fast'>
                <ButtonComponent onClick={() => {
                    history.push(`/teams/${teamId}/options/resetTutorials`);
                }}>
                    <HelpOutline sx={iconStyle} fontSize="small" /> {/* Replaced FontAwesome */}
                    Reset tutorials
                </ButtonComponent>

                <ButtonComponent onClick={() => {
                    history.push(`/teams/${teamId}/options/resignFromTeam`);
                }}>
                    <DeleteOutline sx={iconStyle} fontSize="small" /> {/* Replaced FontAwesome */}
                    Resign from team
                </ButtonComponent>

                <ButtonComponent onClick={() => {
                    history.push(`/teams/${teamId}/options/resetWorldTour`);
                }}>
                    <AssignmentIcon sx={iconStyle} fontSize="small" /> {/* Replaced FontAwesome */}
                    Reset World Tour
                </ButtonComponent>

                <ButtonComponent onClick={() => {
                    history.push(`/teams/${teamId}/options/unlockAllWorldTour`);
                }}>
                    <LockOpenOutlined sx={iconStyle} fontSize="small" /> {/* Replaced FontAwesome */}
                    Unlock All World Tour
                </ButtonComponent>

                <ButtonComponent onClick={() => {
                    history.push(`/teams/${teamId}/options/signOut`);
                }}>
                    <LogoutOutlined sx={iconStyle} fontSize="small" /> {/* Replaced FontAwesome */}
                    Sign out
                </ButtonComponent>

                <ButtonComponent type={Type.SECONDARY} onClick={() => {
                    history.goBack();
                }}>
                    {/* Use startIcon or endIcon for better alignment if ButtonComponent supports it */}
                    {/* Or just text */}
                    <ArrowBack sx={iconStyle} fontSize="small" /> {/* Added Exit icon */}
                    Exit options
                </ButtonComponent>
            </AnimatedStack>
        </PageContainerComponent>
    );
}

// Assuming Options is the main export for routing
export const Options = () => { // Removed props: any
    return (
        <Switch>
            <Route exact path="/teams/:teamId/options" component={OptionsList} />
            <Route path="/teams/:teamId/options/resignFromTeam" component={ResignFromTeam} />
            <Route path="/teams/:teamId/options/resetTutorials" component={ResetTutorials} />
            <Route path="/teams/:teamId/options/resetWorldTour" component={ResetWorldTour} />
            <Route path="/teams/:teamId/options/unlockAllWorldTour" component={UnlockAllWorldTour} />
            <Route path="/teams/:teamId/options/signOut" component={SignOut} />
        </Switch>
    );
}
